import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import logo from "../../images/logo2.svg";
import "../../Pages/LaunchingSoon.css";

export default function LaunchLegalHeader() {
  return (
    <div className="launch-page">
      <header className="launch-nav launch-wrap launch-legal-header">
        <Link to="/" aria-label="MediSYS launching page">
          <img src={logo} alt="MediSYS Pharmacy" />
        </Link>
        <nav aria-label="Launch page navigation">
          <Link to="/" className="launch-contact">
            <ArrowLeft size={16} aria-hidden="true" />
            Back to launch
          </Link>
        </nav>
      </header>
    </div>
  );
}
